<template>
  <div v-if="dataSource.series[0].data.length">
    <MixedCarts :dataSource="dataSource" />
  </div>
</template>

<script>
import MixedCarts from "../../../charts/ApexCartsMixed.vue";
export default {
  name: "Onboarding",
  components: {
    MixedCarts,
  },
  data() {
    return {
      dataSource: {
        type: "bar",
        height: 350,
        series: [
          {
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            type: "bar",
            height: 350,
          },
          colors: ["#269ffb"],
          plotOptions: {
            bar: {
              borderRadius: 5,
              barHeight: "85%",

              horizontal: true,
              dataLabels: {
                position: "bottom",
              },
            },
          },
          dataLabels: {
            enabled: true,
            textAnchor: "start",
            style: {
              colors: ["#fff"],
            },
            formatter: function (val, opt) {
              return opt.w.globals.labels[opt.dataPointIndex] + " :  " + val;
            },
            offsetX: 0,
            dropShadow: {
              enabled: true,
              enabledOnSeries: undefined,
              top: 0,
              left: 0,
              blur: 3,
              color: "#000",
              opacity: 0.35,
            },
          },
          stroke: {
            width: 1,
            colors: ["#fff"],
          },
          tooltip: {
            theme: "dark",

            y: {
              title: {
                formatter: function (val, opt) {
                  return val;
                },
              },
            },
          },
          yaxis: {
            labels: {
              show: false,
            },
          },
          legend: {
            show: false,
          },
        },
      },
    };
  },
  computed: {
    onboarding() {
      const data = this.$store.state.analytics.onboarding;
      return data;
    },
  },
  mounted() {
    let res = [];
    if (this.onboarding) {
      for (const [key, value] of Object.entries(this.onboarding)) {
        console.log(
          this.$t(`analytics.onbording.DADA.Steps.${key}`) ? "yes" : "no"
        );
        res.push({
          x: !this.$t(`analytics.onbording.DADA.Steps.${key}`).includes(
            "analytics.onbording"
          )
            ? this.$t(`analytics.onbording.DADA.Steps.${key}`)
            : key,
          y: value,
        });
      }
      this.dataSource.series[0].data = res.sort(function (a, b) {
        return b.y - a.y;
      });
    }
  },
};
</script>
